<template>
    <Navbar/>
    <div class="sale-container body" :dir="rtl ? 'rtl' : 'ltr'">


    <div class="sale-card">

    <h2>{{ $t('sale.title') }}</h2>

    <form @submit.prevent="submitSale">

    <!-- CUSTOMER SEARCH -->
    <div class="form-group search-box" ref="customerBox">

    <label>{{ $t('sale.customerSearch') }}</label>

    <input
    v-model="customerSearch"
    @input="filterCustomers"
    @focus="openCustomerPanel"
    class="form-input"
    :placeholder="$t('sale.customerPlaceholder')"
    />

    <div v-if="showCustomerPanel" class="result-panel">

    <div
    v-for="c in filteredCustomers"
    :key="c.id"
    class="result-item"
    @click="selectCustomer(c)"
    >
    {{ c.name }} - {{ c.phone }}
    </div>

    </div>

    </div>


    <!-- CUSTOMER NAME -->
    <div class="form-group">
    <label>{{ $t('sale.customerName') }}</label>
    <input class="form-input" v-model="customerName" readonly/>
    </div>


    <!-- PRODUCT SEARCH -->
    <div class="form-group search-box" ref="productBox">

    <label>{{ $t('sale.productSearch') }}</label>

    <input
    v-model="productSearch"
    @input="filterProducts"
    @focus="openProductPanel"
    class="form-input"
    :placeholder="$t('sale.productPlaceholder')"
    />

    <div v-if="showProductPanel" class="result-panel">

    <div
    v-for="p in filteredProducts"
    :key="p.id"
    class="result-item"
    @click="selectProduct(p)"
    >
    {{ p.name }} ({{ p.unit }})
    </div>

    </div>

    </div>


    <!-- PRODUCT NAME -->
    <div class="form-group">
    <label>{{ $t('sale.productName') }}</label>
    <input class="form-input" v-model="productName" readonly/>
    </div>


    <!-- QUANTITY -->
    <div class="form-group">

    <label>{{ $t('sale.quantity') }}</label>

    <div class="quantity-row">

    <input
    type="number"
    step="0.01"
    v-model.number="quantity"
    class="form-input"
    @input="calculatePrice"
    />

    <span class="unit">{{ productUnit }}</span>

    </div>

    </div>


    <!-- UNIT PRICE -->
    <div class="form-group">
    <label>{{ $t('sale.unitPrice') }}</label>
    <input class="form-input" :value="unitPrice" readonly/>
    </div>


    <!-- EXTRA -->
    <div class="form-group">
    <label>{{ $t('sale.extraPrice') }}</label>
    <input class="form-input" :value="extraPrice" readonly/>
    </div>


    <!-- DISCOUNT -->
    <div class="form-group">
    <label>{{ $t('sale.discount') }}</label>
    <input class="form-input" :value="discount" readonly/>
    </div>


    <button class="submit-btn">
    {{ $t('sale.submit') }}
    </button>

    </form>

    </div>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue"

export default {

components:{Navbar},

data(){
return{

customerSearch:"",
customerName:"",
showCustomerPanel:false,

productSearch:"",
productName:"",
productUnit:"",
showProductPanel:false,

quantity:0,

unitPrice:0,
extraPrice:0,
discount:0,

selectedProduct:null,

customers:[
{id:1,name:"علی رضایی",phone:"0912123456"},
{id:2,name:"محمد احمدی",phone:"0912555666"},
{id:3,name:"حسین کریمی",phone:"0935444333"}
],

products:[
{id:1,name:"سیب قرمز",unit:"کیلو",price:50000},
{id:2,name:"موز",unit:"کیلو",price:70000},
{id:3,name:"گوجه",unit:"کیلو",price:30000}
],

filteredCustomers:[],
filteredProducts:[]

}
},

computed:{
rtl(){
return this.$i18n.locale==="fa" || this.$i18n.locale==="ar"
}
},

mounted(){
document.addEventListener("click",this.handleClickOutside)
},

beforeUnmount(){
document.removeEventListener("click",this.handleClickOutside)
},

methods:{

handleClickOutside(event){

if(
this.$refs.customerBox &&
!this.$refs.customerBox.contains(event.target)
){
this.showCustomerPanel=false
}

if(
this.$refs.productBox &&
!this.$refs.productBox.contains(event.target)
){
this.showProductPanel=false
}

},

/* CUSTOMER SEARCH */

openCustomerPanel(){
this.showCustomerPanel=true
},

filterCustomers(){

const q=this.customerSearch.toLowerCase()

this.filteredCustomers=this.customers.filter(c=>
c.name.includes(q) || c.phone.includes(q)
)

this.showCustomerPanel=true
},

selectCustomer(c){

this.customerName=c.name
this.customerSearch=c.name
this.showCustomerPanel=false

},


/* PRODUCT SEARCH */

openProductPanel(){
this.showProductPanel=true
},

filterProducts(){

const q=this.productSearch.toLowerCase()

this.filteredProducts=this.products.filter(p=>
p.name.includes(q)
)

this.showProductPanel=true
},

selectProduct(p){

this.selectedProduct=p

this.productName=p.name
this.productSearch=p.name
this.productUnit=p.unit

this.showProductPanel=false

this.calculatePrice()

},


/* PRICE CALCULATION */

calculatePrice(){

if(!this.selectedProduct){

this.unitPrice=0
this.extraPrice=0
this.discount=0
return

}

const base=this.selectedProduct.price * this.quantity

this.unitPrice=base
this.extraPrice=base*0.05
this.discount=base*0.02

},


submitSale(){

const sale={

customer:this.customerName,
product:this.productName,
quantity:this.quantity,
unitPrice:this.unitPrice,
extra:this.extraPrice,
discount:this.discount

}

console.log(sale)

}

},

watch:{

productSearch(val){

if(!val){

this.productName=""
this.productUnit=""
this.selectedProduct=null

this.unitPrice=0
this.extraPrice=0
this.discount=0

}

}

}

}
</script>

<style scoped>

.sale-container{
display:flex;
justify-content:center;
padding:2rem;
background:var(--bg);
min-height:100vh;
}

.sale-card{
background:var(--card-bg);
border:1px solid var(--border);
border-radius:12px;
padding:2rem;
width:600px;
box-shadow:var(--shadow);
}

h2{
text-align:center;
color:var(--primary);
margin-bottom:20px;
}

.form-group{
margin-bottom:15px;
}

.form-input{
width:100%;
padding:8px;
border-radius:6px;
border:1px solid var(--border);
background:var(--input-bg);
color:var(--text);
}

.quantity-row{
display:flex;
gap:10px;
align-items:center;
}

.unit{
color:var(--text-secondary);
}

.submit-btn{
width:100%;
padding:10px;
background:var(--primary);
border:none;
color:white;
border-radius:6px;
cursor:pointer;
margin-top:10px;
}

/* SEARCH */

.search-box{
position:relative;
}

.result-panel{
position:absolute;
top:100%;
left:0;
right:0;
background:var(--card-bg);
border:1px solid var(--border);
border-radius:6px;
max-height:180px;
overflow:auto;
z-index:100;
box-shadow:var(--shadow);
}

.result-item{
padding:8px;
cursor:pointer;
}

.result-item:hover{
background:var(--hover);
}

</style>
